<template>
  <div class="category-video-view">
    <!-- HEADER -->
    <HeaderView :title="this.categoryName" :isLeft="true" />
    <!-- <HeaderView title="影片類型列表" /> -->

    <!-- 影片類型列表 -->
    <van-list
      v-model="loading"
      :finished="finished"
      finished-text="没有更多了"
      @load="onLoad"
    >
      <div
        class="video-info"
        v-for="item in list"
        :key="item.videoID"
        @click="toVideoDetail(item)"
      >
        <div>
          <van-image class="video-img" :src="item.photo" lazy-load />
        </div>

        <div class="video-label">
          &ensp;{{ item.videoName }}．{{ item.actorName }}．{{ item.onDate }}
        </div>

        <!-- 分割線 -->
        <van-divider
          :style="{
            borderColor: 'black',
            margin: '0.3125rem 0.3125rem 0.0625rem 0.3125rem',
          }"
        ></van-divider>
      </div>
    </van-list>
  </div>
</template>

<script>
// CategoryVideoView : 影片類型列表
// call by Home.vue, CategoryVideoView.vue

import { List, Cell, CellGroup, Image, Divider } from "vant";
import HeaderView from "../HeaderView/HeaderView.vue";

export default {
  name: "categoryVideoView",
  components: {
    [List.name]: List,
    [Cell.name]: Cell,
    [CellGroup.name]: CellGroup,
    [Image.name]: Image,
    [Divider.name]: Divider,
    HeaderView,
  },
  data() {
    return {
      title: "分類影片",
      navViewShow: false, //顯示分頁表頭

      list: [],
      loading: false,
      finished: false,
      page: 0,

      categoryID: 0,
      categoryName: "",
    };
  },
  computed: {},
  created() {
    this.categoryID = this.$route.query.categoryID;
    this.categoryName = this.$route.query.categoryName;
  }, //created
  methods: {
    onLoad() {
      if (this.finished) {
        return;
      }

      this.loading = true;

      var category = this.categoryID;

      this.page++;
      var secret = process.env.VUE_APP_SECRET;
      var base_url = process.env.VUE_APP_BASE_URL;
      var timeKey = this.$timeKey();
      var postKey = this.$md5(
        category.toString() + this.page.toString() + timeKey + secret
      );

      var url = base_url + "/CategoryVideoPlus";

      var that = this;
      this.$ajax
        .get(url, {
          params: {
            Category: category,
            Page: that.page,
            PostKey: postKey,
          },
        })
        .then(function (response) {
          let res = response.data.data;

          if (res.length > 0) {
            //把 data 加入 list
            res.forEach((item) => {
              that.list.push(item);
            });
            //小於 30 筆,沒有下一頁
            if (res.length < 10) {
              that.finished = true;
            }
          } else {
            that.finished = true;
          }

          // 加载状态结束
          that.loading = false;
        })
        .catch(function (err) {
          // 出錯
          console.log(err);
          that.loading = false;
        });
    }, //onLoad

    /*     toVideoDetail(item) {
      this.$router.push({
        name: "videodetail",
        query: {
          videoID: item.videoID,
          videoName: item.videoName
        }
      });
    }, //toVideoDetail */

    toVideoDetail(item) {
      this.$router.push({
        name: "videodetailx",
        query: {
          videoDetail: JSON.stringify(item),
        },
      });
    }, //toVideoDetail

    initData() {
      return true;
    },
    handlePopstate(event) {
      this.onLoad();
    },
  },
  mounted() {
    window.addEventListener('popstate', this.handlePopstate);
  },
  beforeDestroy() {
    window.removeEventListener('popstate', this.handlePopstate);
  }, //methods

  activated() {
    if (this.categoryID != this.$route.query.categoryID) {
      this.list = [];
      this.page = 0;
      this.categoryID = this.$route.query.categoryID;
      this.categoryName = this.$route.query.categoryName;
      this.onLoad();
    } else {
      //do nothing;
    }
  },
};
</script>

<style>
.category-video-view {
  padding-top: 2.8125rem;
  padding-bottom: 3.125rem;
  font-family: "Arial", "Helvetica", "sans-serif";
}

.category-video-view .video-img {
  width: 100%;
  padding: 0.3125rem 0 0.3125rem 0;
}
.category-video-view .video-label {
  /* padding: 0 0.3125rem 0 0.3125rem; */
  font-family: "Arial", "Helvetica", "sans-serif";
}
.category-video-view .video-hr {
  margin: 0.3125rem 0.3125rem 0.0625rem 0.3125rem;
}
</style>
